export default "__VITE_ASSET__COsZrll4__"